<template>
  <div
    class="fill-height"
  >
    <vx-left-menu
      :show="showLeftMenu"
      :id-incendio-selected="idIncendioSelected"
      :sim-collapsed="simCollapsed"
      @exit="hideLeftMenu"
    />

    <!-- <v-content fill-height> -->
    <vx-map
      :show-incendios-cards="showIncendiosCards"
      @selectIncendio="selectIncendio"
      @isSimCollapsed="handleCollapse"
    />
    <!-- </v-content> -->
  </div>
</template>

<script>
import Map from './Map'
import LeftMenu from './leftmenu/LeftMenu'

export default {
  name: 'Map',

  components: {
    'vx-left-menu': LeftMenu,
    'vx-map': Map
  },

  data: () => ({
    showLeftMenu: false,

    idIncendioSelected: null,
    showIncendiosCards: true,
    drawer: true,
    incendio: {},
    simCollapsed: false
  }),

  mounted() {
    this.$eventHub.$on('stopSimulacionesLeftMenu', (idIncendio) => {
      this.selectIncendio(idIncendio)
    })
  },

  methods: {
    selectIncendio(idIncendio) {
      this.showLeftMenu = true
      this.idIncendioSelected = idIncendio
      this.showIncendiosCards = false
    },

    hideLeftMenu(showSymbology) {
      this.showLeftMenu = false
      this.idIncendioSelected = null
      this.showIncendiosCards = !showSymbology
    },

    handleCollapse(state) {
      this.simCollapsed = state
    }
  }
}
</script>

<style scoped></style>
